import(/* webpackMode: "eager" */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/not-found.tsx");
